import {
  Companion_getInstance1co6rysm0hsdc as Companion_getInstance,
  charset1dribv3ku48b1 as charset,
} from './ContentTypes.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function contentType(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.b56().d2p('Content-Type');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_getInstance().ut(tmp0_safe_receiver);
  }
  return tmp;
}
function contentType_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.b56().d2p('Content-Type');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_getInstance().ut(tmp0_safe_receiver);
  }
  return tmp;
}
function contentLength(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.b56().d2p('Content-Length');
  return tmp0_safe_receiver == null ? null : toLongOrNull(tmp0_safe_receiver);
}
function charset_0(_this__u8e3s4) {
  var tmp0_safe_receiver = contentType_0(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
}
//region block: exports
export {
  charset_0 as charset3qqtyytkmxogi,
  contentLength as contentLength2suzxu1lzutku,
  contentType as contentType2zzm38yxo3syt,
  contentType_0 as contentType317fn4f991q9a,
};
//endregion

//# sourceMappingURL=HttpMessageProperties.mjs.map
